import { MAIN_PAGE_ROUTE } from '@constants/routes';
import type React from 'react';
import { Navigate } from 'react-router';
import { usePermissions } from '../../hooks/usePermissions';
import type { IRestrictedRoute } from '../../interfaces/IRoutes';

export const RestrictedRoute: React.FC<IRestrictedRoute> = ({
  requiredPermissions,
  component: Component,
  ...rest
}) => {
  const { hasPermissions } = usePermissions();

  if (!hasPermissions(requiredPermissions)) {
    return <Navigate to={MAIN_PAGE_ROUTE} />;
  }

  return <Component {...rest} />;
};
